import React from 'react';
import { TouchableOpacity, View, Image } from 'react-native';
import { CheckboxProps } from './CheckboxProps';
import { styles } from './Checkbox.styles';

import rectangle from '../../assets/rectangle.png';
import check from '../../assets/check.png';

const Checkbox: React.FC<CheckboxProps> = ({
  active,
  disabled,
  indeterminate,
  onChange,
  testID,
}) => {
  const handlePress = () => {
    if (!disabled) {
      onChange(!active);
    }
  };

  const getImageSource = () => {
    if (indeterminate) {
      return rectangle;
    }
    if (active) {
      return check;
    }
    return null;
  };

  const getImageStyle = () => {
    if (indeterminate) {
      return [styles.image, styles.indeterminateImage];
    }
    if (active) {
      return [styles.image, styles.activeImage];
    }
    return null;
  };

  return (
    <TouchableOpacity onPress={handlePress} disabled={disabled} testID={testID}>
      <View
        style={[
          styles.container,
          disabled ? styles.disabled : active ? styles.active : styles.inactive,
        ]}>
        {getImageSource() && <Image source={getImageSource()} style={getImageStyle()} />}
      </View>
    </TouchableOpacity>
  );
};

export default Checkbox;
